var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C9.23858 3 7 5.23858 7 8V10.3017C6.81392 10.3712 6.64484 10.4566 6.48728 10.5616C6.12 10.81 5.81 11.12 5.56697 11.4832C5.07723 12.2181 5.00826 13.2078 5 15V15.0029C5.00826 16.7951 5.07184 17.7807 5.56159 18.5156C5.81 18.8829 6.12 19.1929 6.48319 19.436C7.2181 19.9257 8.2078 19.9947 10 20.0029H14C15.7922 19.9947 16.7778 19.9311 17.5127 19.4413C17.88 19.1929 18.19 18.8829 18.433 18.5197C18.9228 17.7848 18.9917 16.7951 19 15.0029V15C18.9917 13.2078 18.9282 12.2222 18.4384 11.4873C18.19 11.12 17.88 10.81 17.5168 10.567C17.3582 10.4613 17.1878 10.3752 17 10.3051V8C17 5.23858 14.7614 3 12 3ZM15 10.0156V8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8V10.0151C9.30297 10.0057 9.63473 10.0017 10 10H14C14.3651 10.0017 14.6969 10.0059 15 10.0156ZM11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "lock.3d58f2a6.svg";
export { ForwardRef as ReactComponent };